// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
import GlobalStyles from '../../../config/styles';

// Every colour here is explicit. Inside the account panel an unset colour
// inherits white and the text disappears - which is what happened to the
// amount label on the issue-voucher screen.
const styles = () => ({
  screenTitle: {
    margin: '16px 0 0 0',
    textAlign: 'center',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px 20px 32px 20px',
  },
  intro: {
    width: '100%',
    maxWidth: 480,
    margin: 0,
    textAlign: 'center',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  dateRow: {
    width: '100%',
    maxWidth: 480,
    marginTop: 16,
    display: 'flex',
    // The two pickers sit side by side on a desktop and stack on a phone,
    // where 480px of width is not there to be shared.
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  label: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
  },
  help: {
    width: '100%',
    maxWidth: 480,
    margin: '4px 0 0 0',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  notice: {
    width: '100%',
    maxWidth: 480,
    margin: '16px 0 0 0',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
  },
  error: {
    width: '100%',
    maxWidth: 480,
    margin: '16px 0 0 0',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_REJECT,
  },
  reportPanel: {
    width: '100%',
    maxWidth: 480,
    marginTop: 20,
    padding: 16,
    borderRadius: 8,
    border: '1px solid #E5E5E5',
  },
  reportTitle: {
    margin: 0,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
  },
  reportDescription: {
    margin: '4px 0 12px 0',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  button: {
    width: '100%',
  },
});

export default styles;
